import { render } from "./edit-comment.vue?vue&type=template&id=74ec88f6&ts=true"
import script from "./edit-comment.vue?vue&type=script&lang=ts"
export * from "./edit-comment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__